export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";